import { Maybe, Operation } from '../../../__generated__/globalTypes'

import {
  ItemFragment,
  itemFragmentString,
} from '../../fragments/__generated__/ItemFragment'

import { sendDelayFragmentString } from '../../fragments/__generated__/SendDelayFragment'

import { giftVariationFragmentString } from '../../fragments/__generated__/GiftVariationFragment'

import { amountString } from '../../fragments/__generated__/Amount'

import { priceString } from '../../fragments/__generated__/Price'

import getItemsRawString from '../GetItems.graphql'

const getItemsString = [
  getItemsRawString,
  itemFragmentString,
  sendDelayFragmentString,
  giftVariationFragmentString,
  amountString,
  priceString,
].join('\n\n')

export type GetItemsData = {
  items: ItemFragment[]
}

export type GetItemsVariables = {
  offset?: Maybe<number>
  limit?: Maybe<number>
  search?: Maybe<string>
  category?: Maybe<string>
}

export type GetItems = Operation<GetItemsData, GetItemsVariables>

export const GetItems = ({
  offset,
  limit,
  search,
  category,
}: GetItemsVariables = {}): GetItems => ({
  query: getItemsString,
  variables: {
    offset,
    limit,
    search,
    category,
  },
})
